var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrediant(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1530,
    viewBox: "0 0 1440 1530",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15,
    filter: "url(#filter0_f_2208_29025)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M710.656 1003.42C878.36 1003.42 1014.31 859.832 1014.31 682.709C1014.31 505.586 878.36 362 710.656 362C542.951 362 407 505.586 407 682.709C407 859.832 542.951 1003.42 710.656 1003.42Z",
    fill: "#FF6D4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.66 1601.42C1233.36 1601.42 1369.31 1457.83 1369.31 1280.71C1369.31 1103.59 1233.36 960 1065.66 960C897.951 960 762 1103.59 762 1280.71C762 1457.83 897.951 1601.42 1065.66 1601.42Z",
    fill: "#FEBE58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.656 1579.42C687.599 1579.42 821.312 1435.83 821.312 1258.71C821.312 1081.59 687.599 938 522.656 938C357.713 938 224 1081.59 224 1258.71C224 1435.83 357.713 1579.42 522.656 1579.42Z",
    fill: "#DE2BAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1535.84 1425.7C1703.54 1425.7 1839.5 1282.11 1839.5 1104.99C1839.5 927.868 1703.54 784.282 1535.84 784.282C1368.14 784.282 1232.18 927.868 1232.18 1104.99C1232.18 1282.11 1368.14 1425.7 1535.84 1425.7Z",
    fill: "#24EDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037.52 890.218C1205.23 890.218 1341.18 889.995 1341.18 889.718C1341.18 889.442 1205.23 889.218 1037.52 889.218C869.818 889.218 733.867 889.442 733.867 889.718C733.867 889.995 869.818 890.218 1037.52 890.218Z",
    fill: "#ADFF99"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2208_29025",
    x: -137.095,
    y: 0.904999,
    width: 2337.69,
    height: 1961.61,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 180.548,
    result: "effect1_foregroundBlur_2208_29025"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrediant);
export default __webpack_public_path__ + "static/media/grediant.73e25e4cc452da873c41826592a20f17.svg";
export { ForwardRef as ReactComponent };